"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = checkFormControlProps;
var DEFAULT_ERROR = 'Form control should only be either `controlled` or `uncontrolled` component.';
function checkFormControlProps(_ref) {
  var defaultValue = _ref.defaultValue,
    value = _ref.value,
    onChange = _ref.onChange;
  return function () {
    var errorMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ERROR;
    if (defaultValue !== undefined && value !== undefined) {
      throw new Error(errorMsg);
    }
    if (value !== undefined && onChange === undefined) {
      throw new Error(errorMsg);
    }
  };
}